import { Switch } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';
import { AnimationPanelViews } from 'types/AnimationPanelViews';

import Drawer from './Drawer';

const DrawerBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #e6e6e6;
  margin: 10px;
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;
`;

const SettingRow = styled.div`
  display: flex;
  font-weight: bold;
  align-items: center;
  justify-content: space-between;
  &:not(:last-child) {
    margin-bottom: 15px;
  }
`;

const Label = styled.span`
  flex: 1;
  font-size: 14px;
`;

const ColorInput = styled.input`
  width: 30px;
  height: 30px;
  padding: 0;
  border: 2px solid #bfbfbf;
  border-radius: 10px;
  background: none;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  &::-webkit-color-swatch-wrapper {
    padding: 0;
  }

  &::-webkit-color-swatch {
    border: none;
    border-radius: 5px;
  }

  &::-moz-color-swatch {
    border: none;
    border-radius: 5px;
  }
`;

function CanvasDrawer() {
  const store_animation = store.animation;

  const handleBorderToggle = (checked: boolean) => {
    // TODO: should feed through the `checked` value than use a toggle
    //  method to rely on coincidental state
    store_animation?.toggleShowBorder();
  };

  const handleCheckerboardToggle = (checked: boolean) => {
    // TODO: should feed through the `checked` value than use a toggle
    //  method to rely on coincidental state
    store_animation?.toggleShowCheckerboard();
  };

  const handleColorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    store_animation?.setBackgroundColor(e.target.value);
  };

  return (
    <Drawer label="Canvas Settings" panelName={AnimationPanelViews.CANVAS}>
      <DrawerBodyContainer>
        <SettingRow>
          <Label>Show Border</Label>
          <Switch
            checked={store_animation?.showBorder}
            disabled={!store_animation}
            onChange={handleBorderToggle}
          />
        </SettingRow>
        <SettingRow>
          <Label>Show Checkerboard</Label>
          <Switch
            checked={store_animation?.showCheckerboard}
            disabled={!store_animation}
            onChange={handleCheckerboardToggle}
          />
        </SettingRow>
        <SettingRow>
          <Label>Background Color</Label>
          <ColorInput
            type="color"
            value={store_animation?.backgroundColor}
            disabled={!store_animation}
            onChange={handleColorChange}
          />
        </SettingRow>
      </DrawerBodyContainer>
    </Drawer>
  );
}

export default observer(CanvasDrawer);
